import * as RoleLoadedActions from '../actions/roleLoaded.action'

// 初始化数据值
const initialState: boolean = false;

export function reducer(state: boolean = initialState, action: RoleLoadedActions.RoleLoadedActions) {

  switch (action.type) {
    case RoleLoadedActions.SET_ROLE_LOADED:
      return action.payload;
    default:
      return state;
  }
}